// dependencies imports ⇒
import React, { useState } from "react";
import moment from "moment";
// assets and scss imports ⇒
import "./consentRequestForm.scss";
// project file imports(UI components) ⇒
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import ComponentSpecificLoader from "../../../UI Component/Loader/ComponentSpecificLoader";
// const file imports(helper methods, etc) ⇒
import { ADD_ABHA_RECORD } from "../AbhahealthRecordApiHandler/apiConstants";
import { HEALTH_INFO_TYPE_OPTIONS, PURPOSE_OPTIONS } from "../constant";
import DatePickerInputField from "../../../common/DatePickerInputFeild";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

function AbhaConsentRequestForm(props) {
  // const declarations ⇒
  const { appointmentDetails, handleSelectPage, getAbhaConsentList } = props;

  const [pusposeOptions, setPurposeOptions] = useState(PURPOSE_OPTIONS);
  const [pusposeValue, setPurposeValue] = useState("");
  const [healthTypeOptions, setHealthTypeOptions] = useState(
    HEALTH_INFO_TYPE_OPTIONS
  );
  const [startDate, setStartDate] = useState("");
  const [startDateValue, setStartDateValue] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateValue, setEndDateValue] = useState("");
  const [loader, setLoader] = useState(false);

  // let or var declarations ⇒
  // life cycle methods ⇒
  // API Calls ⇒

  const onAddAbhaRecord = () => {
    let healthOptions = healthTypeOptions
      .filter((option) => option.selected)
      .map((option) => option.value);

    if (
      !pusposeValue ||
      !startDate ||
      !endDate ||
      healthOptions.length === 0 ||
      moment(startDate).isAfter(moment(endDate))
    ) {
      console.error("Mandatory fields are missing");
    } else {
      let reqPayload = {
        preferred_abha_address: appointmentDetails?.preferred_abha_address,
        purpose_of_request: pusposeValue,
        start_date: startDate,
        end_date: endDate,
        health_info_type: healthOptions,
        appointment_id: appointmentDetails?.appointment_id,
      };
      setLoader(true);
      const resData = c2cPostApiHandler(ADD_ABHA_RECORD, reqPayload);
      resData.then(([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            handleSelectPage(3);
            getAbhaConsentList();
          } else {
            setLoader(false);
          }
        } else {
          setLoader(false);
        }
      });
    }
  };

  // Helper methods ⇒

  const getSelectedPurposeValue = (val) => {
    setPurposeOptions((options) =>
      options.map((opt) => ({ ...opt, selected: opt.value === val }))
    );
  };

  const getPurposeValue = () => {
    let selected = pusposeOptions.find((obj) => obj.selected);
    return selected?.label ? selected.label : "";
  };

  // Actions ⇒

  const handlePurposeChange = (val) => {
    getSelectedPurposeValue(val.value);
    setPurposeValue(val.value);
  };

  const handleStartDateChange = (date) => {
    let originalDate = new Date(date);
    let formattedDate = originalDate.toISOString();
    setStartDate(formattedDate);
    setStartDateValue(moment(date).format("DD MMM YYYY"));
  };

  const handleEndDateChange = (date) => {
    let originalDate = new Date(date);
    let formattedDate = originalDate.toISOString();
    setEndDate(formattedDate);
    setEndDateValue(moment(date).format("DD MMM YYYY"));
  };

  const handleHealthTypeChange = (index) => {
    setHealthTypeOptions((options) =>
      options.map((option, i) =>
        i === index ? { ...option, selected: !option.selected } : option
      )
    );
  };

  const handleSelectAll = () => {
    setHealthTypeOptions((options) =>
      options.map((option) => ({ ...option, selected: true }))
    );
  };

  // create UI ⇒

  const consentRequestUi = () => {
    return (
      <div className="consent-request-form-container">
        <div className="consent-request-form">
          <div className="consent-request-form-heading">
            <div className="crfc-heading">Consent Request Form</div>
          </div>
          <div className="crfc-purpose-request-wrapper">
            <div className="crfc-purpose-request-title">
              Purpose Of Request:
            </div>
            <FormInputWithHeader
              className="view-details-poc-input"
              value={getPurposeValue()}
              inputType="dropdown"
              placeholder="Select One"
              options={pusposeOptions}
              handleOnChangeInput={handlePurposeChange}
            ></FormInputWithHeader>
          </div>
          <div className="crfc-date-inputs-wrapper">
            <div className="crfc-purpose-request-title">Health Info:</div>
            <div className="crfc-date-inputs">
              <DatePickerInputField
                placeholder="Select Date From"
                value={startDateValue}
                maxDate={new Date()}
                handleDateChange={handleStartDateChange}
              />
              <div className="crfc-des">-</div>
              <DatePickerInputField
                placeholder="Select Date To"
                value={endDateValue}
                maxDate={new Date()}
                handleDateChange={handleEndDateChange}
              />
            </div>
          </div>
          <div className="crfc-health-info-type-wrapper">
            <div className="crfc-health-info-title-sellect-all">
              <div className="crfc-health-info-title">Health Info Type:</div>
              <div className="crfc-select-all" onClick={handleSelectAll}>
                Select All
              </div>
            </div>
            <div className="crfc-health-info-type-options-wrapper">
              {healthTypeOptions.map((object, index) => (
                <div key={index}>
                  <label className="container-checkbox">
                    <div className="crfc-health-info-label">
                      {object?.label}
                    </div>
                    <input
                      type="checkbox"
                      name="enable_online"
                      checked={object.selected}
                      onChange={() => handleHealthTypeChange(index)}
                    />
                    <span className="option-checkmark"></span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div onClick={onAddAbhaRecord} className="crfc-request-btn">
          <span>Request Consent</span>
        </div>
      </div>
    );
  };

  //
  return (
    <div className="consent-form-ui-container">
      {loader && <ComponentSpecificLoader />}
      {consentRequestUi()}
    </div>
  );
}

export default AbhaConsentRequestForm;
